import axios from '@/jslib/axios'

export const getHzmbList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/hzmb/list',
    params,
    ...other
  })
}
export const getHzmbDetail= params => {
  return axios({
    method: 'get',
    url: '/admin/hzmb/detail',
    params
  })
}
export const updateHzmbStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/hzmb/update/status',
    data
  })
}
export const editHzmbOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/hzmb/edit',
    data
  })
}
export const addHzmbRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/hzmb/remark/add',
    data
  })
}
